export default "__VITE_ASSET__f0dd4fd7__"